import { render, staticRenderFns } from "./OportunidadesList.vue?vue&type=template&id=033ebe7c&"
import script from "./OportunidadesList.vue?vue&type=script&lang=js&"
export * from "./OportunidadesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports